// 2024-01-26 - the vue3 replacement is to use the composition api - see useSearchFilter - this will go away once port complete
import { pathOr } from "ramda";
const SearchFilterMixin = {
  methods: {
    // Standard Search filter on all lists input searches
    filterDataBySearchTerm(searchTerm, propsListToSearch, data) {
      if (!searchTerm) {
        return data;
      }

      let result = data.filter((row) => {
        let isIncluded = false;
        for (let key of propsListToSearch) {
          let rowValue = pathOr("", key.split("."), row).toString();
          if (
            rowValue.includes &&
            rowValue.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      return result;
    },
  },
};

export default SearchFilterMixin;
